import { render, staticRenderFns } from "./AirTransport.vue?vue&type=template&id=0e02fb48&"
import script from "./AirTransport.vue?vue&type=script&lang=js&"
export * from "./AirTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports